import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import { SubHeader } from "../StyledComponents/AppStyles";
import {
  VerifiedSection,
  VerifiedText,
  VerifiedOptionWrapper,
  OptionContent,
  IndicioBankingLogo,
  CheckMarkShield,
  HeraldicPeopleVerified,
} from "../StyledComponents/VerifiedStyles";
import { useEffect } from "react";

function VerifiedOption({ title, description, price, previousPrice, options }) {
  const optionsList = options.map((option, index) => {
    return (
      <li key={index}>
        <span>
          <CheckMarkShield />
        </span>
        {option}
      </li>
    );
  });

  return (
    <VerifiedOptionWrapper>
      <OptionContent>
        <h4>{title}</h4>
        <p>{description}</p>
        <div>
          <p>${previousPrice}</p>
          <h4>
            ${price}
            <span>/mo</span>
          </h4>
        </div>
        <div>
          <h6>Perks & Coverage</h6>
          <ul>{optionsList}</ul>
        </div>
      </OptionContent>
      <button>Choose This Package</button>
    </VerifiedOptionWrapper>
  );
}

export default function VerifiedPage({ resetStates, verifiedCredAttributes }) {
  const effectRan = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      if (!effectRan.current) {
        effectRan.current = true;
      } else {
        return () => {
          effectRan.current = false;
        };
      }
    }

    if (Object.keys(verifiedCredAttributes).length === 0) {
      console.log(
        "No verified credentials found. Redirecting to landing page."
      );
      navigate("/");
    }
  }, [verifiedCredAttributes]);

  const handleReset = () => {
    resetStates();
    navigate("/");
  };

  return (
    <VerifiedSection>
      <SubHeader>
        <p>
          Welcome to the Heraldic Insurance portion of Indicio’s Banking
          verifiable credential demo. This is a mock website designed to show
          the process of using a credential across different websites.
        </p>
      </SubHeader>
      <div>
        <span>
          <IndicioBankingLogo />
        </span>
        <VerifiedText>
          <h1>
            You're verified!{" "}
            <span>
              Welcome,{" "}
              {verifiedCredAttributes?.given_names
                ? verifiedCredAttributes.given_names
                : ""}
            </span>
          </h1>
          <p>
            Now that we’ve verified your Bank Account credential and membership
            status with the Indicio Banking Demo, you are eligible to receive
            discounted quotes for our Heraldic Shield Essential insurance
            packages.
          </p>
          <p>
            <b>This concludes Indicio’s Banking verifiable credential demo.</b>{" "}
            <u onClick={handleReset}>
              Click here to restart the demo from the beginning.
            </u>
          </p>
        </VerifiedText>
        <div>
          <span>
            <HeraldicPeopleVerified />
          </span>
          <VerifiedOption
            title="IDShield Basic"
            description="Essential identity theft protection"
            price="8.99"
            previousPrice="14.99"
            options={[
              "$500,000 identify theft insurance",
              "24/7 live support from our Customer Care Team",
              "Data Breach Alerts",
              "Heraldic NetShield Suite",
            ]}
          />
          <VerifiedOption
            title="IDShield Basic + CreditShield Basic"
            description="Comprehensive identify + financial theft protection"
            price="15.99"
            previousPrice="21.99"
            options={[
              "$750,000 identify theft insurance",
              "$500,000 credit theft insurance",
              "24/7 live support from our Customer Care Team",
              "Data Breach Alerts",
              "Heraldic NetShield Suite",
              "Bank Account & Credit Monitoring",
            ]}
          />
          <VerifiedOption
            title="IDShield Plus + CreditShield Plus"
            description="Premium identity + financial theft protection"
            price="27.99"
            previousPrice="44.99"
            options={[
              "$750,000 identify theft insurance",
              "$750,000 credit theft insurance",
              "24/7 live support from our Customer Care Team",
              "Fraud & Theft Resolution",
              "Investment Monitoring & Alerts",
              "Data Breach Monitoring & Alerts",
              "Bank Account & Credit Monitoring",
              "Monthly & Annual Credit Report",
            ]}
          />
        </div>
      </div>
    </VerifiedSection>
  );
}
